import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { CaseUploadService } from 'src/app/case-upload.service';
import { ClientContractPackageService } from 'src/app/client-contract-package.service';
import { ClientContractProfileService } from 'src/app/client-contract-profile.service';
import { PersonalDataEntryComponent } from '../personal-data-entry/personal-data-entry.component';
import { ComponentDataEntryComponent } from '../component-data-entry/component-data-entry.component';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  isLinear = true;
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('personalDataEntry') personalDataEntryComponent: PersonalDataEntryComponent;
  @ViewChild('componentDataEntry') componentDataEntryComponent: ComponentDataEntryComponent;
  selectedStep = 0;
  stepCompleted = 0;

  gdbValue: boolean = false;
  isDataSaved: boolean = false
  instructions: string
  addressComponent: boolean = false
  educationComponent: boolean = false
  employmentComponent: boolean = false
  identityComponent: boolean = false
  gapvfnComponent: boolean = false
  cvanalysisComponent: boolean = false
  uanComponent: boolean = false
  twentysixasComponent: boolean = false
  creditcheckComponent: boolean = false
  credittransComponent: boolean = false
  epfoComponent: boolean = false
  crconlineComponent: boolean = false
  socialmediaComponent: boolean = false
  globalmediasearchComponent: boolean = false
  facisl3Component: boolean = false
  gstcheckComponent: boolean = false
  directorshipcheckComponent: boolean = false
  ofacComponent: boolean = false
  drugtestComponent: boolean = false
  voterIdComponent: boolean = false
  panComponent: boolean = false
  passportComponent: boolean = false
  dlComponent: boolean = false
  adharComponent: boolean = false
  bankStatementComponent: boolean = false
  globaldatabaseComponent: boolean = false
  statusInDb: string


  compNextDisable = true;
  personalNextDisable = true;


  caseId: any
  case_id: any
  profile: any
  package: any
  alacart: any
  component_id: any
  components: any[] = []
  navItems: any[] = []

  someCondition = [];


  constructor(
    private caseUploadService: CaseUploadService,
    private clientContractProfileService: ClientContractProfileService,
    private clientContractPackageService: ClientContractPackageService,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.getComponentDetails()
    this.someCondition = new Array(this.navItems.length).fill(false)
  }

  get buttonPersonalDisable() {
    return this.personalDataEntryComponent?.personalDetailsDataEntryForm?.invalid;
  }
  get buttonComponentDisable() {
    return this.componentDataEntryComponent?.gdbValue || ((!this.componentDataEntryComponent?.fileUploadRequired || (this.componentDataEntryComponent?.fileUploadRequired && this.componentDataEntryComponent?.isFileUploaded)) && !this.componentDataEntryComponent?.isDataSaved && !this.componentDataEntryComponent?.componentDataEntryForm.invalid && this.componentDataEntryComponent?.componentDataEntryForm.dirty);
  }

  prevStep() {
    this.selectedStep--;
    if (this.stepper) {
      this.compNextDisable = true
      this.stepper.previous();
    }
  }

  nextStep1() {
    if (this.stepper) {
      this.stepper.next();
    }
  }

  nextStepPersonal() {
    this.selectedStep++;
    if (this.stepper) {
      this.stepper.next();
    }
  }
  
  nextStepComp() {
    if (this.selectedStep < this.stepCompleted) {
      this.selectedStep++;
      if (this.stepper) {
        this.stepper.next();
      }
    }
  }

  respData(data) {
    if (data) {
      this.stepCompleted = this.selectedStep + 1;
    }
    this.compNextDisable = data
  }

  receiveData(data: any) {
    this.stepCompleted++;
    this.compNextDisable = true
    // this.selectedStep++;
    // if (this.stepper) {
    //   this.stepper.next();
    // }  
  }

  receiveDataPersonal(data) {
    if (data) {
      this.personalNextDisable = false;
      // this.stepCompleted = 1
      // this.nextStepPersonal()
    }
  }

  persoanlDataRemarks(data) {
    this.someCondition[this.stepper.selectedIndex] = data
  }

  compDataRemarks(data) {
    this.someCondition[this.stepper.selectedIndex - 1] = data
  }

  async getComponentDetails() {
    await this.getCaseDetails()
    this.navItems.push({
      displayName: 'Personal Details',
      access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
      children: [],
      isCompleted: false
    })
    if (this.profile != null) {
      this.components = <any[]>await this.getProfileDetails()
    } else if (this.package != null) {
      this.components = <any[]>await this.getPackageDetails()
    } else if (this.alacart != null) {
      this.components = <any[]>await this.getalacartDetails()
    }

    await this.setComponentMenuItems()
    this.navItems.push({ displayName: 'Authorization', access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), children: [], isCompleted: false })
  }

  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }
  getProfileDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractProfileService.getClientContractProfileDetails(this.profile + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          this.components = response2.clientContractProfileComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              this.globaldatabaseComponent = true
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Professional Reference'
              // Added By Navin On 15/2/24
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName == 'UAN'
            } else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            } else if (item.componentName == 'credittrans') {
              item.displayName == 'Credit Check - TransUnion'
            } else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            } else if (item.componentName == 'crconline') {
              item.displayName == 'Court Record (CRC ) - Law Firm (Online)'
            } else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            } else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            } else if (item.componentName == 'globalmediasearch') {
              item.displayName = 'Global Media Search'
            } else if (item.componentName == 'facisl3') {
              item.displayName = 'FACIS L3 Check'
            } else if (item.componentName  == 'passport') {
              item.displayName = 'Passport Check'
            } else if (item.componentName  == 'directorshipcheck') {
              item.displayName = 'Directorship Check'
            } else if (item.componentName  == 'gstcheck') {
              item.displayName = 'GST Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
  getPackageDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractPackageService.getClientContractPackageDetails(this.package + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          this.components = response2.clientContractPackageComponents
          this.components.forEach(item => {

            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            } else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            } else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            } else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            } else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            } else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            } else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            } else if (item.componentName == 'globalmediasearch') {
              item.displayName = 'Global Media Search'
            } else if (item.componentName == 'facisl3') {
              item.displayName = 'FACIS L3 Check'
            }else if (item.componentName  == 'passport') {
              item.displayName = 'Passport Check'
            } else if (item.componentName  == 'directorshipcheck') {
              item.displayName = 'Directorship Check'
            } else if (item.componentName  == 'gstcheck') {
              item.displayName = 'GST Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }

  getalacartDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        // this.clientContractPackageService.getClientContractComponentsDetails(this.alacart + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          // console.log("Profile details are ", response2)
          this.components = response2.componentsToCheck
          // console.log("components to check",response2)
          // console.log("components to check",this.components)
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == 'cvanalysis') {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            } else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            } else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            } else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            } else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            } else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            } else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            } else if (item.componentName == 'globalmediasearch') {
              item.displayName = 'Global Media Search'
            } else if (item.componentName == 'facisl3') {
              item.displayName = 'FACIS L3 Check'
            }else if (item.componentName  == 'passport') {
              item.displayName = 'Passport Check'
            } else if (item.componentName  == 'directorshipcheck') {
              item.displayName = 'Directorship Check'
            } else if (item.componentName  == 'gstcheck') {
              item.displayName = 'GST Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }

  ////
  setComponentMenuItems() {
    let promise = new Promise((resolve, reject) => {
      this.components.forEach(item => {
        let childItems = []
        if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
          for (let i = 0; i < item.maxChecks; i++) {
            if (i == 0) {
              childItems.push({ displayName: "Current Employment" + "-" + (i), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [], details: item.details })
              continue
            }
            childItems.push({ displayName: "Previous " + item.displayName + "-" + (i), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [], details: item.details })
          }
        } else {
          for (let i = 0; i < item.maxChecks; i++) {
            childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
          }
        }

        this.navItems.push({ displayName: item.displayName, children: childItems, isDisable: true, details: item.details })
        resolve(true)
      })
    })
    return promise
  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
}
